module.exports = __webpack_public_path__ + "img/other6.c25fe860.png";